import {
  AblyGoodsCardActionType,
  AblyGoodsCardChipType,
} from '../../../../enums';
import type { Entity, GoodsCarouselProps } from './types';
import type { GoodsData } from '@banhala/ui-kit';

export const getGoodsCarouselData = ({
  entity,
}: Pick<GoodsCarouselProps, 'entity'>): Array<GoodsData & Entity> => {
  if (!entity) {
    return [];
  }
  return entity
    .map(({ item, render }, index) => {
      if (!render || !item) {
        return null;
      }
      return {
        ...entity[index],
        sno: item.sno,
        deliveryType: item.delivery_type,
        thumbnail: {
          src: item.image,
          freesSrc: render.data.freeze_image?.url ?? item.image,
          hideLike: !render.data.actions.includes(AblyGoodsCardActionType.Like),
          closedReason: render.data.closed_reason ?? undefined,
          badges: render.data.image_badge_list.map(badge => ({
            uri: badge.image_url,
            width: badge.image_width,
            height: badge.image_height,
          })),
          emblems: render.data.emblems?.map(emblem => ({ uri: emblem.image_url })),
          ranking: render.data.ranking ?? undefined,
        },
        contents: {
          price: {
            price: render.data.price,
            discount: render.data.discount_rate ?? '',
          },
          name: {
            goodsName: item.name,
            marketName: render.data.store_text ?? item.market_name ?? null,
            nameLineCount: render.data.name_lines,
            showBrand: false,
          },
          topNudging: render.data.top_nudging_text ?? undefined,
          priceDescription: render.data.price_description
            ? { name: render.data.price_description.text }
            : undefined,
          cutoff: render.data.cutoff ?? undefined,
          imageAd: render.data.has_ad_badge,
          nudge: render.data.nudging_text ?? undefined,
          chips: (render.data.chips ?? []).map(chip => {
            if (chip.type === AblyGoodsCardChipType.DittoText) {
              return {
                type: chip.type,
                name: chip.name,
                customTag: chip.meta
                  ? {
                      bgColor: chip.meta.bg_color,
                      borderColor: chip.meta.border_color,
                      borderWidth: chip.meta.border_width ?? 0,
                      borderRadius: chip.meta.rounded_corner_radius ?? 0,
                      textColor: chip.meta.text_color,
                      textType: chip.meta.text_style,
                    }
                  : undefined,
              };
            }
            return {
              type: chip.type,
              name: chip.name ?? '',
            };
          }),
        },
      };
    })
    .filter(v => v !== null);
};
